// Force autoplay on all autoplay videos - aggressive mobile/iOS approach
function forceVideoAutoplay() {
  document.querySelectorAll('video-media[autoplay]').forEach(function(videoMedia) {
    videoMedia.setAttribute('loaded', '');
    videoMedia.removeAttribute('show-play-button');
    var video = videoMedia.querySelector('video');
    if (video) {
      video.muted = true;
      video.setAttribute('muted', '');
      video.setAttribute('playsinline', '');
      video.setAttribute('preload', 'auto');
      video.play().catch(function() {});
    }
  });
  document.querySelectorAll('video[autoplay]').forEach(function(video) {
    video.muted = true;
    video.setAttribute('muted', '');
    video.setAttribute('playsinline', '');
    video.setAttribute('preload', 'auto');
    video.play().catch(function() {});
  });
}

function unlockIOSAutoplay() {
  forceVideoAutoplay();
  document.removeEventListener('touchstart', unlockIOSAutoplay);
  document.removeEventListener('scroll', unlockIOSAutoplay);
}

document.addEventListener("DOMContentLoaded", function() {
  forceVideoAutoplay();
  document.addEventListener('touchstart', unlockIOSAutoplay, { once: true, passive: true });
  document.addEventListener('scroll', unlockIOSAutoplay, { once: true, passive: true });
  var observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(m) {
      if (m.addedNodes.length) forceVideoAutoplay();
    });
  });
  observer.observe(document.body, { childList: true, subtree: true });

  const productForm = document.querySelector(".product-form");
  const sampleButton = document.querySelector(".get-sample-button");
  if (productForm && sampleButton) {
    productForm.parentNode.insertBefore(sampleButton, productForm.nextSibling);
  }
});

// ============================================================
// ZELLIGE HOME - Dynamic Recommendations Engine v1.0
// ============================================================

var ZH = window.ZH || {};
ZH.SESSION_KEY = 'zh_session';
ZH.MAX_VIEWED  = 12;

// Current market root path: '/' on the US (primary) market, '/en-gb/' on the UK
// market. EVERY storefront AJAX fetch (products.json, .js, cart.js) must go through
// this prefix, otherwise the API returns primary-market (USD) prices even on /en-gb.
ZH.root = function() {
  var r = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  return r.charAt(r.length - 1) === '/' ? r : r + '/';
};

// Format a major-unit amount (e.g. 82.00) in the ACTIVE market currency so /en-gb
// renders "GBP 82.00" and the US renders "$107.70" - replaces the old hardcoded '$'.
ZH.money = function(amount) {
  if (amount == null || isNaN(amount)) return '';
  var cur = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD';
  var loc = (window.Shopify && Shopify.locale) || 'en';
  try {
    return new Intl.NumberFormat(loc, { style: 'currency', currency: cur }).format(amount);
  } catch (e) {
    return '$' + Number(amount).toFixed(2);
  }
};

ZH.getSession = function() {
  try {
    var raw = sessionStorage.getItem(ZH.SESSION_KEY);
    var s = raw ? JSON.parse(raw) : null;
    if (!s || typeof s !== 'object') s = ZH.defaultSession();
    return s;
  } catch(e) { return ZH.defaultSession(); }
};

ZH.saveSession = function(s) {
  try { sessionStorage.setItem(ZH.SESSION_KEY, JSON.stringify(s)); } catch(e) {}
};

ZH.defaultSession = function() {
  return {
    viewedProducts: [],
    viewedCategories: { mosaic: 0, zellige4x4: 0, trim: 0, other: 0 },
    lastCategory: null,
    addedToCart: [],
    sessionStart: Date.now()
  };
};

ZH.parseColors = function(raw) {
  if (!raw) return [];
  if (Array.isArray(raw)) return raw.map(function(c) { return String(c).trim(); }).filter(Boolean);
  if (typeof raw === 'string') {
    return raw.split(',').map(function(c) { return c.trim(); }).filter(Boolean);
  }
  return [];
};

ZH.trackProduct = function(data) {
  if (!data || !data.id) return;
  var s = ZH.getSession();
  s.viewedProducts = s.viewedProducts.filter(function(p) { return p.id !== data.id; });
  s.viewedProducts.unshift(data);
  if (s.viewedProducts.length > ZH.MAX_VIEWED) s.viewedProducts = s.viewedProducts.slice(0, ZH.MAX_VIEWED);
  var cat = data.category || 'other';
  if (s.viewedCategories[cat] !== undefined) s.viewedCategories[cat]++;
  s.lastCategory = cat;
  ZH.saveSession(s);
};

ZH.initTracker = function() {
  var dataEl = document.getElementById('zh-product-data');
  if (!dataEl) return;
  try {
    var data = JSON.parse(dataEl.textContent);
    data.colors = ZH.parseColors(data.colors);
    ZH.trackProduct(data);
  } catch(e) {}
};

ZH.sessionColors = function() {
  var s = ZH.getSession();
  var colors = [];
  s.viewedProducts.forEach(function(p) {
    (p.colors || []).forEach(function(c) {
      if (colors.indexOf(c) === -1) colors.push(c);
    });
  });
  return colors;
};

ZH.currentColors = function() {
  var dataEl = document.getElementById('zh-product-data');
  if (!dataEl) return [];
  try {
    var data = JSON.parse(dataEl.textContent);
    // Primary: metafield colors
    var colors = ZH.parseColors(data.colors);
    // Fallback: extract color signal from the product handle itself
    // e.g. "zellige-tile-4x4-fez-terra-cota" -> ["fez-terra-cota"]
    if (!colors.length && data.handle) {
      colors = ZH.colorsFromHandle(data.handle);
    }
    return colors;
  } catch(e) { return []; }
};

// Strip style/type prefixes from a handle to isolate the color portion.
// zellige-tile-4x4-fez-terra-cota  -> fez-terra-cota
// lido-mosaic-fez-terra-cotta      -> fez-terra-cotta
// zellige-mosaic-trapezoid-cream   -> cream
// zellige-border-collier-blanc-cream -> blanc-cream
// cream-ft-1                       -> cream
ZH.colorsFromHandle = function(handle) {
  if (!handle) return [];
  var h = handle.toLowerCase();

  // Leading prefixes to strip - order matters (longest first)
  var prefixes = [
    'zellige-tile-4x4-', 'zellige-tile-',
    'zellige-mosaic-trapezoid-', 'zellige-mosaic-tasmim-',
    'zellige-mosaic-pyramidion-', 'zellige-mosaic-pinwheel-',
    'zellige-mosaic-illusion-',
    // Style-specific mosaic prefixes (real handles are zellige-mosaic-{style}-{color})
    // - must precede the bare 'zellige-mosaic-' so the style is stripped too.
    'zellige-mosaic-bishop-', 'zellige-mosaic-chateau-', 'zellige-mosaic-dama-',
    'zellige-mosaic-gio-ponti-', 'zellige-mosaic-chebka-', 'zellige-mosaic-cravat-',
    'zellige-mosaic-',
    'zellige-border-collier-', 'zellige-border-khatem-',
    'zellige-border-drihem-', 'zellige-border-diamas-',
    'zellige-border-zig-zag-', 'zellige-border-',
    'zellige-', 'lido-mosaic-', 'pleat-mosaic-', 'lucky-mosaic-',
    'dalia-mosaic-', 'high-road-mosaic-', 'dew-mosaic-',
    'elio-mosaic-', 'chateau-mosaic-', 'gio-mosaic-', 'khatem-mosaic-',
    'bishop-', 'dama-', '4x4-', 'mosaic-', 'border-', 'tile-'
  ];
  for (var i = 0; i < prefixes.length; i++) {
    if (h.indexOf(prefixes[i]) === 0) { h = h.slice(prefixes[i].length); break; }
  }

  // Strip trailing trim/sample/jpg suffixes
  h = h.replace(/-?ft-[12].*$/, '')
       .replace(/-?sample.*$/, '')
       .replace(/-?0[0-9](-jpg)?$/, '')
       .replace(/^-+|-+$/g, '');

  return h ? [h] : [];
};

ZH.colorMatch = function(productColors, targetColors) {
  if (!productColors || !targetColors || !productColors.length || !targetColors.length) return false;
  return productColors.some(function(c) {
    return targetColors.some(function(t) {
      return c.toLowerCase() === t.toLowerCase();
    });
  });
};

ZH.tagColors = function(product) {
  return (product.tags || [])
    .filter(function(t) { return t.toLowerCase().startsWith('color:'); })
    .map(function(t) { return t.replace(/^color:\s*/i, '').trim(); });
};

// Normalize a color name to handle-safe format: "Atlas Sage" -> "atlas-sage"
ZH.normalizeColor = function(color) {
  return String(color).toLowerCase().trim().replace(/\s+/g, '-').replace(/[^a-z0-9-]/g, '');
};

// Hand-painted tile descriptive colour names -> zellige colour equivalents.
// HPT products use pattern/colour names (Ivy, Ore...) that don't appear in zellige handles.
ZH.HPT_COLOR_MAP = {
  'ivy':      ['atlas-sage', 'forest-green', 'forest'],
  'ore':      ['deep-sea', 'london-sky'],
  'yuzu':     ['sunflower'],
  'earth':    ['fez-terra-cota', 'fez-terra-cotta', 'caramel'],
  'normandi': ['titanium', 'fig', 'blanc'],
  'maroon':   ['maroon'],
  'roe':      ['los-feliz']
};

// Reverse map: zellige colour names -> HPT colour names.
// Needed so that viewing a zellige PDP can still surface the right HPT products
// (e.g. London Sky + Deep Sea -> look for HPT products containing "ore").
ZH.HPT_REVERSE_MAP = {
  'atlas-sage':     ['ivy'],
  'forest-green':   ['ivy'],
  'forest':         ['ivy'],
  'deep-sea':       ['ore'],
  'london-sky':     ['ore'],
  'sunflower':      ['yuzu'],
  'fez-terra-cota': ['earth'],
  'fez-terra-cotta':['earth'],
  'caramel':        ['earth'],
  'titanium':       ['normandi'],
  'fig':            ['normandi'],
  'maroon':         ['maroon'],
  'los-feliz':      ['roe']
};

// Expand colours through both maps so zellige <-> hand-painted matching works
// in either direction (viewing HPT -> find zellige, viewing zellige -> find HPT).
// Also handles combined strings like "atlas-sage-forest-green" that colorsFromHandle
// may return when the Colors metafield is not set - sub-segment lookup finds
// "atlas-sage" inside that string and correctly adds "ivy".
ZH.expandColors = function(colors) {
  var out = [];
  var reverseKeys = Object.keys(ZH.HPT_REVERSE_MAP);
  colors.forEach(function(c) {
    var norm = ZH.normalizeColor(c);
    if (out.indexOf(norm) === -1) out.push(norm);
    // Forward: HPT name -> zellige equivalents
    (ZH.HPT_COLOR_MAP[norm] || []).forEach(function(m) {
      if (out.indexOf(m) === -1) out.push(m);
    });
    // Reverse: zellige name -> HPT equivalents (exact key match)
    (ZH.HPT_REVERSE_MAP[norm] || []).forEach(function(r) {
      if (out.indexOf(r) === -1) out.push(r);
    });
    // Sub-segment reverse: handles combined strings like "atlas-sage-forest-green"
    // where colorsFromHandle couldn't split into individual colours
    reverseKeys.forEach(function(key) {
      if (norm !== key && norm.indexOf(key) !== -1) {
        (ZH.HPT_REVERSE_MAP[key] || []).forEach(function(r) {
          if (out.indexOf(r) === -1) out.push(r);
        });
      }
    });
  });
  return out;
};

// Neutral colours are the universal "goes with everything" tones. When a product
// has a real accent colour alongside cream/blanc, we prioritise the accent so a
// shared "cream" doesn't pull in clashing combos (e.g. Cream + Fez Terra Cotta).
ZH.NEUTRAL_COLORS = ['cream', 'blanc', 'white'];
ZH.isNeutralColor = function(c) {
  return ZH.NEUTRAL_COLORS.indexOf(ZH.normalizeColor(c)) !== -1;
};

// Drop neutral colours from a list IF any non-neutral colour is present.
// "cream + atlas-sage + forest-green" -> ["atlas-sage","forest-green"]
// "cream" (only neutral) -> ["cream"]  (kept, since it's all we have)
ZH.priorityColors = function(colors) {
  var accents = colors.filter(function(c) { return !ZH.isNeutralColor(c); });
  return accents.length ? accents : colors;
};

// Match a product against colors using handle-based matching.
// Strategy 1: full normalized match  e.g. "atlas-sage"   in handle
// Strategy 2: word-level match       e.g. "atlas","sage" in handle (handles typos like fez-terra-cota)
// Strategy 3: tag-based              e.g. "color: Atlas Sage" tag exists
ZH.productMatchesColors = function(product, colors) {
  if (!colors || !colors.length) return false;
  var h = ((product.handle || '') + ' ' + (product.title || '')).toLowerCase();

  return colors.some(function(c) {
    var norm = ZH.normalizeColor(c);
    if (norm.length < 3) return false;

    // Strategy 1: exact normalized string in handle/title
    if (h.indexOf(norm) !== -1) return true;

    // Strategy 2: ALL significant words (>3 chars) appear - "atlas-sage" -> both "atlas" and "sage"
    var words = norm.split('-').filter(function(w) { return w.length > 3; });
    if (words.length && words.every(function(w) { return h.indexOf(w) !== -1; })) return true;
    // Strategy 3: ANY word >=5 chars appears - catches typos like cota/cotta ("terra" still matches)
    if (words.some(function(w) { return w.length >= 5 && h.indexOf(w) !== -1; })) return true;

    // Strategy 3: tag-based (future-proof if tags are ever added)
    var tagColorsArr = ZH.tagColors(product);
    return tagColorsArr.some(function(tc) { return tc.toLowerCase() === c.toLowerCase(); });
  });
};

ZH.fetchCollection = function(handle, limit, callback) {
  fetch(ZH.root() + 'collections/' + handle + '/products.json?limit=' + (limit || 12))
    .then(function(r) { return r.json(); })
    .then(function(data) { callback(null, data.products || []); })
    .catch(function(e) { callback(e, []); });
};

// Cache collection fetches so duplicate slot requests = 1 API call
ZH._colCache = {};
ZH.fetchCollectionCached = function(handle, callback) {
  if (ZH._colCache[handle]) { callback(null, ZH._colCache[handle]); return; }
  ZH.fetchCollection(handle, 250, function(err, products) {
    if (!err) ZH._colCache[handle] = products;
    callback(err, products);
  });
};

// -- Slot config ----------------------------------------------
// Each slot = one card position in "Everything You Need".
// Mosaic slots use Bishop + Chateau; if the visitor is currently viewing
// a Bishop or Chateau product that slot swaps to Dama automatically.
// Fallback handles: verify these match actual Shopify product handles.
// -------------------------------------------------------------
ZH.SLOT_CONFIG = [
  { collection: '4x4-square',   style: null,      fallback: 'zellige-tile-4x4-cream',            badge: '4\u00d74 Zellige'  },
  { collection: '4x4-square',   style: null,      fallback: 'zellige-tile-4x4-blanc',            badge: '4\u00d74 Zellige'  },
  { collection: 'mosaics',      style: 'bishop',  fallback: 'zellige-mosaic-bishop-blanc-cream',  badge: 'Mosaic'       },
  { collection: 'mosaics',      style: 'chateau', fallback: 'zellige-mosaic-chateau-blanc-cream', badge: 'Mosaic'       },
  { collection: 'borders',      style: 'collier', fallback: 'zellige-border-collier-blanc-cream', badge: 'Border'       },
  { collection: 'hand-painted', style: null,      fallback: 'hpt-001-a',                         badge: 'Hand Painted' },
  { collection: 'trims',        style: 'ft-1',    fallback: 'cream-ft-1',                        badge: 'Trim'         },
  { collection: 'trims',        style: 'ft-2',    fallback: 'cream-ft-2',                        badge: 'Trim'         }
];

ZH.productCard = function(product, badgeText) {
  var imgSrc = '';
  if (product.featured_image) imgSrc = product.featured_image;
  else if (product.images && product.images[0]) imgSrc = product.images[0].src;
  var imgParam = imgSrc.indexOf('?') !== -1 ? '&width=400' : '?width=400';
  var imgTag = imgSrc ? '<img src="' + imgSrc + imgParam + '" alt="' + ZH.esc(product.title) + '" loading="lazy">' : '<div class="zh-rec-card__img-placeholder"></div>';
  var price = '';
  if (product.variants && product.variants[0]) {
    var rawPrice = product.variants[0].price;
    // /collections/.../products.json returns string dollars e.g. "108.00"
    // /products/{handle}.js returns integer cents e.g. 10800
    var priceAmount = typeof rawPrice === 'string' ? parseFloat(rawPrice) : rawPrice / 100;
    price = ZH.money(priceAmount);
  }
  var badge = badgeText ? '<span class="zh-rec-badge">' + ZH.esc(badgeText) + '</span>' : '';
  return '<a href="/products/' + product.handle + '" class="zh-rec-card">' +
    '<div class="zh-rec-card__img">' + badge + imgTag + '</div>' +
    '<div class="zh-rec-card__info">' +
      '<p class="zh-rec-card__title">' + ZH.esc(product.title) + '</p>' +
      '<p class="zh-rec-card__price">' + price + '</p>' +
    '</div>' +
  '</a>';
};

ZH.esc = function(str) {
  return String(str || '').replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;');
};

// ============================================================
// Touch Point 1 - PDP "Everything You Need" (slot-based)
// ============================================================

ZH.initInstallPairing = function() {
  var container = document.getElementById('zh-install-pairing');
  if (!container) return;

  // Detect which mosaic style is currently being viewed so we can swap
  // Bishop -> Dama or Chateau -> Dama for that slot
  var dataEl = document.getElementById('zh-product-data');
  var currentStr = '';
  try {
    var pdata = JSON.parse(dataEl.textContent);
    currentStr = ((pdata.handle || '') + ' ' + (pdata.title || '')).toLowerCase();
  } catch(e) {}
  var viewingBishop  = currentStr.indexOf('bishop')  !== -1;
  var viewingChateau = currentStr.indexOf('chateau') !== -1;

  // Build effective slot config - swap Bishop/Chateau to Dama when viewing that style
  var slotConfig = ZH.SLOT_CONFIG.map(function(slot) {
    if (slot.style === 'bishop' && viewingBishop) {
      return { collection: 'mosaics', style: 'dama', fallback: 'zellige-mosaic-dama-blanc-cream', badge: 'Mosaic' };
    }
    if (slot.style === 'chateau' && viewingChateau) {
      return { collection: 'mosaics', style: 'dama', fallback: 'zellige-mosaic-dama-blanc-cream', badge: 'Mosaic' };
    }
    return slot;
  });

  // Colours: expand HPT descriptive names to zellige equivalents before matching
  var colors = ZH.currentColors();
  var allColors = ZH.expandColors(colors.length ? colors : ZH.sessionColors());
  console.log('[ZH] Install pairing - allColors:', allColors);

  // Unique collections needed across effective slot config
  var uniqueCollections = slotConfig.reduce(function(acc, s) {
    if (acc.indexOf(s.collection) === -1) acc.push(s.collection);
    return acc;
  }, []);

  // Fallback handles that need individual fetching
  var fallbackHandles = slotConfig
    .map(function(s) { return s.fallback; })
    .filter(function(h) { return !!h; })
    .filter(function(h, i, arr) { return arr.indexOf(h) === i; });

  var totalFetches = uniqueCollections.length + fallbackHandles.length;
  var done = 0;
  var colData = {};
  var fallbackData = {};

  function checkDone() {
    done++;
    if (done === totalFetches) ZH.fillInstallSlots(container, colData, fallbackData, allColors, slotConfig);
  }

  uniqueCollections.forEach(function(handle) {
    ZH.fetchCollectionCached(handle, function(err, products) {
      colData[handle] = err ? [] : products;
      checkDone();
    });
  });

  fallbackHandles.forEach(function(handle) {
    fetch(ZH.root() + 'products/' + handle + '.js')
      .then(function(r) { return r.json(); })
      .then(function(p) { fallbackData[handle] = p; checkDone(); })
      .catch(function() { fallbackData[handle] = null; checkDone(); });
  });
};

ZH.fillInstallSlots = function(container, colData, fallbackData, colors, slotConfig) {
  slotConfig = slotConfig || ZH.SLOT_CONFIG;
  console.log('[ZH] fillInstallSlots - session colors:', colors);
  var usedIds = [];

  var slots = slotConfig.map(function(slot) {
    var products = colData[slot.collection] || [];

    // Narrow by style keyword in handle/title
    var pool = slot.style ? products.filter(function(p) {
      return (p.handle + ' ' + p.title).toLowerCase().indexOf(slot.style) !== -1;
    }) : products;

    // Color-matched candidate (not already used).
    // Prioritise accent colours: when the viewed product has a real colour
    // alongside cream/blanc, match ONLY on the accent so a shared neutral does
    // not surface a clashing combo (e.g. Cream + Atlas Sage pulling in a
    // Cream + Fez Terra Cotta). If no accent match exists we deliberately fall
    // through to the clean blanc/cream fallback rather than a cream combo.
    var matchColors = ZH.priorityColors(colors);
    var matched = matchColors.length ? pool.filter(function(p) {
      return ZH.productMatchesColors(p, matchColors) && usedIds.indexOf(p.id) === -1;
    }) : [];

    // Cream/blanc neutral within the style pool - used when color match fails
    // and the hardcoded fallback handle is unavailable.
    // Disabled for hand-painted: almost every HPT title ends in "+ Cream"
    // so this would always grab a random Cream HPT instead of a proper fallback.
    // Prefer pure-neutral "blanc" products over cream+accent combos so the
    // fallback stays clean (Blanc + Cream, not Cream + Fez Terra Cotta).
    var neutralInPool = (slot.collection !== 'hand-painted') ? pool.filter(function(p) {
      var s = (p.handle + ' ' + p.title).toLowerCase();
      return (s.indexOf('cream') !== -1 || s.indexOf('blanc') !== -1) && usedIds.indexOf(p.id) === -1;
    }) : [];
    neutralInPool.sort(function(a, b) {
      var an = ((a.handle + ' ' + a.title).toLowerCase().indexOf('blanc') !== -1) ? 1 : 0;
      var bn = ((b.handle + ' ' + b.title).toLowerCase().indexOf('blanc') !== -1) ? 1 : 0;
      return bn - an;
    });

    var result = null;

    if (matched.length) {
      result = matched[0];
    } else if (slot.fallback && fallbackData[slot.fallback]) {
      result = fallbackData[slot.fallback];
    } else if (neutralInPool.length) {
      result = neutralInPool[0];
    } else {
      result = pool.find(function(p) { return usedIds.indexOf(p.id) === -1; }) || pool[0] || null;
    }

    if (result) usedIds.push(result.id);
    return result ? { product: result, badge: slot.badge } : null;
  }).filter(Boolean);

  if (!slots.length) { container.style.display = 'none'; return; }

  var cards = slots.map(function(s) { return ZH.productCard(s.product, null); }).join('');
  container.innerHTML =
    '<div class="zh-rec-section">' +
      '<div class="zh-rec-header">' +
        '<p class="zh-rec-eyebrow">Complete Your Installation</p>' +
        '<h3 class="zh-rec-heading">Everything You Need</h3>' +
      '</div>' +
      '<div class="zh-rec-rail">' + cards + '</div>' +
    '</div>';
  container.removeAttribute('hidden');
};

// ============================================================
// Touch Point 2 - Recently Viewed Rail
// ============================================================

ZH.initRecentlyViewed = function() {
  var container = document.getElementById('zh-recently-viewed');
  if (!container) return;
  var s = ZH.getSession();
  var currentId = container.dataset.currentId ? parseInt(container.dataset.currentId, 10) : null;
  var products = s.viewedProducts.filter(function(p) { return p.id !== currentId; }).slice(0, 8);
  if (products.length < 1) { container.style.display = 'none'; return; }
  var cards = products.map(function(p) {
    var imgParam = p.image && p.image.indexOf('?') !== -1 ? '&width=400' : '?width=400';
    var imgTag = p.image ? '<img src="' + p.image + imgParam + '" alt="' + ZH.esc(p.title) + '" loading="lazy">' : '';
    var price = p.price ? ZH.money(p.price / 100) : '';
    return '<a href="' + p.url + '" class="zh-rec-card">' +
      '<div class="zh-rec-card__img">' + imgTag + '</div>' +
      '<div class="zh-rec-card__info">' +
        '<p class="zh-rec-card__title">' + ZH.esc(p.title) + '</p>' +
        '<p class="zh-rec-card__price">' + price + '</p>' +
      '</div>' +
    '</a>';
  }).join('');
  container.innerHTML =
    '<div class="zh-rec-section">' +
      '<div class="zh-rec-header">' +
        '<p class="zh-rec-eyebrow">Your Session</p>' +
        '<h3 class="zh-rec-heading">Recently Viewed</h3>' +
      '</div>' +
      '<div class="zh-rec-rail zh-rec-rail--centered">' + cards + '</div>' +
    '</div>';
  container.removeAttribute('hidden');
};

// ============================================================
// Touch Point 3 - Cart Drawer Upsell
// ============================================================

// Each IS_* checks both handle and title so cart items whose handle
// doesn't carry the type keyword (e.g. color-matched "zellige-trim-atlas-sage")
// are still correctly categorised.
ZH._ht = function(h, t) { return ((h || '') + ' ' + (t || '')).toLowerCase(); };
ZH.IS_4X4    = function(h, t) { return ZH._ht(h, t).indexOf('4x4') !== -1; };
ZH.IS_TRIM   = function(h, t) {
  var s = ZH._ht(h, t);
  return s.indexOf('ft-1') !== -1 || s.indexOf('ft-2') !== -1 || s.indexOf('trim') !== -1;
};
ZH.IS_BORDER = function(h, t) { return ZH._ht(h, t).indexOf('border') !== -1; };
// Mosaic = "mosaic" in handle/title, and not a 4x4/trim/border
ZH.IS_MOSAIC = function(h, t) {
  var s = ZH._ht(h, t);
  return s.indexOf('mosaic') !== -1 && !ZH.IS_4X4(h, t) && !ZH.IS_TRIM(h, t) && !ZH.IS_BORDER(h, t);
};

ZH.ensureCartUpsellContainer = function() {
  var existing = document.getElementById('zh-cart-upsell');
  if (existing) return existing;
  var drawer = document.querySelector('cart-drawer');
  if (!drawer) return null;
  // Find the inner scroll area or footer of the cart drawer
  var anchor = drawer.querySelector('.cart-drawer__scrollable') ||
               drawer.querySelector('[class*="cart-drawer__content"]') ||
               drawer.querySelector('[class*="cart__scrollable"]') ||
               drawer;
  var div = document.createElement('div');
  div.id = 'zh-cart-upsell';
  div.setAttribute('hidden', '');
  // Append after first child or at beginning
  if (anchor.firstChild) {
    anchor.insertBefore(div, anchor.firstChild.nextSibling || anchor.firstChild);
  } else {
    anchor.appendChild(div);
  }
  return div;
};

ZH.initCartUpsell = function() {
  var container = ZH.ensureCartUpsellContainer();
  if (!container) return;
  fetch(ZH.root() + 'cart.js')
    .then(function(r) { return r.json(); })
    .then(function(cart) { ZH.renderCartUpsell(container, cart); })
    .catch(function() {});
};

ZH.renderCartUpsell = function(container, cart) {
  var items = cart.items || [];
  if (!items.length) { container.setAttribute('hidden', ''); return; }
  var hasMosaic = items.some(function(i) { return ZH.IS_MOSAIC(i.handle, i.title); });
  var has4x4   = items.some(function(i) { return ZH.IS_4X4(i.handle, i.title); });
  var hasTrim  = items.some(function(i) { return ZH.IS_TRIM(i.handle, i.title); });

  // Extract colors from cart item handles - same method as PDP
  var cartColors = [];
  items.forEach(function(item) {
    ZH.colorsFromHandle(item.handle).forEach(function(c) {
      if (cartColors.indexOf(c) === -1) cartColors.push(c);
    });
  });
  var colors = cartColors.length ? cartColors : ZH.sessionColors();
  console.log('[ZH] Cart upsell colors:', colors);

  if (!hasMosaic) {
    ZH.renderCartSection(container, {
      eyebrow: 'Customers Also Add',
      heading: 'Complete the Look with a Mosaic',
      collection: 'mosaics',
      badge: 'Mosaic',
      filter: null,
      colors: colors,
      fallbacks: [
        { handle: 'zellige-mosaic-trapezoid-cream', badge: 'Mosaic' },
        { handle: 'zellige-mosaic-tasmim-cream',    badge: 'Mosaic' }
      ]
    });
  } else if (!has4x4) {
    ZH.renderCartSection(container, {
      eyebrow: 'Complete Your Installation',
      heading: 'Pair With 4\u00d74 Zellige',
      collection: '4x4-square',
      badge: '4\u00d74 Zellige',
      filter: null,
      colors: colors,
      fallbacks: [
        { handle: 'zellige-tile-4x4-cream', badge: '4\u00d74 Zellige' },
        { handle: 'zellige-tile-4x4-blanc', badge: '4\u00d74 Zellige' }
      ]
    });
  } else if (!hasTrim) {
    ZH.renderCartSection(container, {
      eyebrow: 'The Final Touch',
      heading: 'Add a Trim Piece',
      collection: 'trims',
      badge: 'Trim',
      filter: null,
      colors: colors,
      fallbacks: [
        { handle: 'cream-ft-1', badge: 'Trim' },
        { handle: 'cream-ft-2', badge: 'Trim' }
      ]
    });
  } else {
    container.setAttribute('hidden', '');
  }
};

ZH.renderCartSection = function(container, cfg) {
  container.innerHTML = '<div class="zh-cart-upsell-loader"><span></span><span></span><span></span></div>';
  container.removeAttribute('hidden');

  // Category-specific fallbacks are passed via cfg.fallbacks as { handle, badge } objects.
  // Always real products - never show an empty placeholder.
  var fallbackList = cfg.fallbacks || [
    { handle: 'zellige-tile-4x4-cream', badge: '4\u00d74 Zellige' },
    { handle: 'zellige-tile-4x4-blanc', badge: '4\u00d74 Zellige' }
  ];

  ZH.fetchCollectionCached(cfg.collection, function(err, products) {
    if (err || !products.length) { container.setAttribute('hidden', ''); return; }
    if (cfg.filter) products = products.filter(cfg.filter);

    // Step 1: colour-matched products first.
    // Prioritise accent colours over neutrals (cream/blanc) so a shared neutral
    // doesn't surface clashing combos; fall back to the full set if none match.
    var usedIds = [];
    var display = [];
    var matchColors = ZH.priorityColors(cfg.colors);
    var matched = matchColors.length ? products.filter(function(p) {
      return ZH.productMatchesColors(p, matchColors);
    }) : [];
    matched.slice(0, 3).forEach(function(p) {
      display.push({ product: p, badge: cfg.badge });
      usedIds.push(p.id);
    });

    // Step 2: fill remaining slots from the rest of the collection
    if (display.length < 3) {
      products.forEach(function(p) {
        if (display.length >= 3) return;
        if (usedIds.indexOf(p.id) === -1) {
          display.push({ product: p, badge: cfg.badge });
          usedIds.push(p.id);
        }
      });
    }

    if (!display.length) { container.setAttribute('hidden', ''); return; }

    var needed = 3 - display.length;
    if (needed <= 0) {
      ZH._renderCartHTML(container, cfg, display);
      return;
    }

    // Step 3: collection has < 3 products total - fetch hardcoded fallbacks
    var displayHandles = display.map(function(d) { return d.product.handle; });
    var fallbacksNeeded = fallbackList
      .filter(function(fb) { return displayHandles.indexOf(fb.handle) === -1; })
      .slice(0, needed);

    if (!fallbacksNeeded.length) {
      ZH._renderCartHTML(container, cfg, display);
      return;
    }

    var pending = fallbacksNeeded.length;
    var extras = [];

    fallbacksNeeded.forEach(function(fb) {
      fetch(ZH.root() + 'products/' + fb.handle + '.js')
        .then(function(r) { return r.json(); })
        .then(function(p) {
          if (p && p.id) extras.push({ product: p, badge: fb.badge });
          pending--;
          if (pending === 0) ZH._renderCartHTML(container, cfg, display.concat(extras).slice(0, 3));
        })
        .catch(function() {
          pending--;
          if (pending === 0) ZH._renderCartHTML(container, cfg, display.concat(extras).slice(0, 3));
        });
    });
  });
};

ZH._renderCartHTML = function(container, cfg, display) {
  var cards = display.map(function(d) { return ZH.productCard(d.product, d.badge); }).join('');
  container.innerHTML =
    '<div class="zh-cart-upsell">' +
      '<div class="zh-cart-upsell__header">' +
        '<p class="zh-rec-eyebrow">' + ZH.esc(cfg.eyebrow) + '</p>' +
        '<p class="zh-cart-upsell__heading">' + ZH.esc(cfg.heading) + '</p>' +
      '</div>' +
      '<div class="zh-cart-upsell__grid">' + cards + '</div>' +
    '</div>';
};

// ============================================================
// Color Panel - slides in left of cart drawer
// ============================================================

ZH.initColorPanel = function() {
  // Create panel DOM once on page load so it's ready
  if (document.getElementById('zh-color-panel')) return;

  var panel = document.createElement('div');
  panel.id = 'zh-color-panel';
  panel.className = 'zh-color-panel';
  panel.setAttribute('aria-hidden', 'true');
  panel.innerHTML =
    '<div class="zh-color-panel__header">' +
      '<p class="zh-color-panel__title" id="zh-color-panel-title"></p>' +
      '<button class="zh-color-panel__close" aria-label="Close panel">' +
        '<svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">' +
          '<path d="M1 1L13 13M13 1L1 13" stroke="currentColor" stroke-width="1.5"/>' +
        '</svg>' +
      '</button>' +
    '</div>' +
    '<div class="zh-color-panel__body" id="zh-color-panel-body"></div>';

  panel.querySelector('.zh-color-panel__close').addEventListener('click', ZH.closeColorPanel);
  document.body.appendChild(panel);

  // If cart drawer closes -> close the panel too
  var drawer = document.querySelector('cart-drawer');
  if (drawer) {
    new MutationObserver(function(mutations) {
      mutations.forEach(function(m) {
        if (m.type === 'attributes' && m.attributeName === 'open' && !drawer.hasAttribute('open')) {
          ZH.closeColorPanel();
        }
      });
    }).observe(drawer, { attributes: true });
  }
};

ZH.openColorPanel = function(colors, label) {
  // Measure cart drawer width so panel sits flush against it
  var drawer = document.querySelector('cart-drawer');
  if (drawer) {
    var w = drawer.offsetWidth || drawer.getBoundingClientRect().width || 440;
    document.documentElement.style.setProperty('--zh-cart-w', w + 'px');
  }

  var panel = document.getElementById('zh-color-panel');
  if (!panel) { ZH.initColorPanel(); panel = document.getElementById('zh-color-panel'); }
  if (!panel) return;

  var titleEl = document.getElementById('zh-color-panel-title');
  if (titleEl) titleEl.textContent = (label ? label.toUpperCase() + ' \u2014 ' : '') + 'ALL PRODUCTS';

  panel.classList.add('zh-color-panel--open');
  panel.setAttribute('aria-hidden', 'false');

  ZH.loadColorPanelProducts(colors);
};

ZH.closeColorPanel = function() {
  var panel = document.getElementById('zh-color-panel');
  if (!panel) return;
  panel.classList.remove('zh-color-panel--open');
  panel.setAttribute('aria-hidden', 'true');
};

ZH.loadColorPanelProducts = function(colors) {
  var body = document.getElementById('zh-color-panel-body');
  if (!body) return;
  body.innerHTML = '<div class="zh-cart-upsell-loader"><span></span><span></span><span></span></div>';

  var collectionsToSearch = ['4x4-square', 'mosaics', 'trims', 'borders', 'hand-painted'];
  var allMatched = [];
  var pending = collectionsToSearch.length;

  collectionsToSearch.forEach(function(handle) {
    ZH.fetchCollectionCached(handle, function(err, products) {
      if (!err && products.length) {
        var m = colors.length ? products.filter(function(p) {
          return ZH.productMatchesColors(p, colors);
        }) : products.slice(0, 8);
        allMatched = allMatched.concat(m);
      }
      pending--;
      if (pending === 0) {
        // Deduplicate by id
        var seen = {};
        var unique = allMatched.filter(function(p) {
          if (seen[p.id]) return false;
          seen[p.id] = true;
          return true;
        });
        ZH.renderColorPanelProducts(body, unique);
      }
    });
  });
};

ZH.renderColorPanelProducts = function(body, products) {
  if (!products.length) {
    body.innerHTML = '<p class="zh-color-panel__empty">No matching products found.</p>';
    return;
  }
  var cards = products.map(function(p) { return ZH.productCard(p, null); }).join('');
  body.innerHTML = '<div class="zh-color-panel__grid">' + cards + '</div>';
};

ZH.watchCartDrawer = function() {
  var drawer = document.querySelector('cart-drawer');
  if (!drawer) return;
  var observer = new MutationObserver(function(mutations) {
    for (var i = 0; i < mutations.length; i++) {
      var m = mutations[i];
      if (m.type === 'attributes' && m.attributeName === 'open' && drawer.hasAttribute('open')) {
        setTimeout(ZH.initCartUpsell, 350);
        break;
      }
      if (m.type === 'childList') {
        setTimeout(ZH.initCartUpsell, 200);
        break;
      }
    }
  });
  observer.observe(drawer, { attributes: true, childList: true, subtree: false });
};

document.addEventListener('DOMContentLoaded', function() {
  ZH.initTracker();
  ZH.initInstallPairing();
  ZH.initRecentlyViewed();
  ZH.initColorPanel();
  ZH.watchCartDrawer();
  setTimeout(ZH.initCartUpsell, 600);
});

window.ZH = ZH;

// ============================================================

document.querySelectorAll('.get-sample-button').forEach(btn => {
  btn.addEventListener('click', (e) => {
    e.preventDefault();
    const sampleHandle = document.getElementById('sample-product-data').dataset.sampleHandle;
    fetch(`/products/${sampleHandle}.js`)
      .then(res => res.json())
      .then(product => {
        const variantId = product.variants[0].id;
        const formData = new FormData();
        formData.append('id', variantId);
        formData.append('quantity', 1);
        const cartDrawer = document.querySelector('cart-drawer');
        let sections = 'cart-drawer,shopify-section-cart-counter';
        if (cartDrawer && typeof cartDrawer.getSectionsToRender === 'function') {
          const drawerSections = cartDrawer.getSectionsToRender();
          if (Array.isArray(drawerSections) && drawerSections.length) {
            sections = drawerSections.map(section => section.section).join(',');
          }
        }
        formData.append('sections', sections);
        formData.append('sections_url', window.location.pathname);
        return fetch('/cart/add.js', { method: 'POST', body: formData });
      })
      .then(res => {
        const cartDrawer = document.querySelector('cart-drawer');
        let sections = 'cart-drawer,shopify-section-cart-counter';
        if (cartDrawer && typeof cartDrawer.getSectionsToRender === 'function') {
          const drawerSections = cartDrawer.getSectionsToRender();
          if (Array.isArray(drawerSections) && drawerSections.length) {
            sections = drawerSections.map(section => section.section).join(',');
          }
        }
        return fetch(`/?sections=${sections}`);
      })
      .then(res => res.json())
      .then(sectionsResponse => {
        const cartDrawer = document.querySelector('cart-drawer');
        if (cartDrawer && typeof cartDrawer.renderContents === 'function') {
          cartDrawer.renderContents({ sections: sectionsResponse });
          cartDrawer.open();
        } else if (cartDrawer && typeof cartDrawer.open === 'function') {
          cartDrawer.open();
        }
        window.location.reload();
      })
      .catch(err => { console.error('\u274c Add to cart error:', err); });
  });
});
/* ============================================================
   Roomvo on collection cards - launches the visualizer for the
   card's product (roomvo.startStandaloneVisualizer, no reload).
   Delegated on document so it survives AJAX filtering/pagination.
   ============================================================ */
document.addEventListener('click', function (e) {
  var btn = e.target.closest('.card-roomvo');
  if (!btn) return;
  e.preventDefault();
  e.stopPropagation();
  var code = btn.getAttribute('data-roomvo-product-code');
  if (code && window.roomvo && typeof window.roomvo.startStandaloneVisualizer === 'function') {
    window.roomvo.startStandaloneVisualizer(code);
  }
});
